"use client";

import { useCallback, useRef } from "react";
import Script from "next/script";
import klaroConfig from "../klaro-config";

export default function KlaroClient() {
    const initialized = useRef(false);
    const setupKlaro = useCallback(() => {
        const consentWindow = window as Window & {
            klaro?: { setup: (config: typeof klaroConfig) => void };
        };
        if (!initialized.current && consentWindow.klaro) {
            consentWindow.klaro.setup(klaroConfig);
            initialized.current = true;
        }
    }, []);

    return (
        <>
            <div id="cookie-banner" />
            <Script
                id="klaro-consent-manager"
                src="https://cdn.kiprotect.com/klaro/v0.7.21/klaro.js"
                strategy="afterInteractive"
                onReady={setupKlaro}
            />
        </>
    );
}
